const moneyIsPositive = {
  computesRequired: true,
  getMessage: field => 'O campo ' + field + ' deve ser positivo',
  validate (value) {
    const formatedValue = value.replace('R$ ', '').replace(',', '.')
    return +formatedValue > 0
  }
}

export default moneyIsPositive



// WEBPACK FOOTER //
// ./src/customValidators/moneyIsPositive.js